import React, { useEffect, useState } from 'react';
import Styles from './StickyProductAnchor.module.scss';
import Row from '../ResponsiveRow/row';
import { countZero, viewport } from '../../utils/utils';
import Cookies from 'js-cookie';
import { createCartV2 } from '../../services/LineTableService';
import { CHF, DEFAULT_WIRELINE_BUNDLE, FIXNET, MOBILE, TABLET } from '../../utils/constants';
import { LineTableBasicPropConfig } from '../../services';
import { ADDTOCART, STICKYLINETABLE } from '../../Analytics/AnalyticsConstants';
import { createPortal } from 'react-dom';
import { trackEligibleItem } from '../../models/Analytics/items';

const StickyProductAnchor = ({ content, offerData, lineCheckCallBack }: any) => {
  const cartEndPoint = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
  const [isVisible, setIsVisible] = useState(false);
  const [offsetVal, setOffsetVal] = useState(false);
  const [head, setHead] = useState('noFalconStyle');
  const [head2, setHead2] = useState('noFalconStyle');

  const [drop, setDrop] = useState(false);
  const viewPort = viewport();
  const selectedProduct = content?.filter(
    (product: any) => product?.productId === offerData?.id
  )?.[0];
  let productPrice: number = 0;
  if (offerData?.derivedPrice) {
    productPrice = offerData?.derivedPrice?.[0]?.value;
  } else {
    productPrice = offerData?.prices?.[0]?.value;
  }

  const scroller = (benefit: any) => {
    const ele = benefit?.id && document.getElementById(benefit?.id);
    setDrop(false);
    if (ele) {
      ele.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  };

  const callCart = () => {
    //track event add to cart
    offerData?.id && trackEligibleItem(ADDTOCART, [offerData], '', STICKYLINETABLE);
    offerData?.id &&
      createCartV2(
        [offerData],
        '',
        offerData?.promoId ? offerData?.promoId : '',
        cartEndPoint,
        MOBILE // need to changed according to producttype
      )
        .then((res) => {
          Cookies.remove('one-commerce-cartId', { path: '/' });
          // saving newly created cartid in the cookies.
          Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
          Cookies.set('cartProduct', selectedProduct?.productId, { path: '/' });
          window.location.href = selectedProduct?.checkoutUrl ?? '';
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
  };

  const callCartWin = () => {
    const bundle = localStorage.getItem('lineCheckResponse');
    const eligibleBundle = bundle && JSON.parse(bundle);
    const linecheckId: any = Cookies.get('one-commerce-linecheckcorrelationid');
    const address: any = Cookies.get('chAddressJson');
    const code = selectedProduct?.productId ?? '';
    const isAvailable = address && eligibleBundle && eligibleBundle?.eligibleBundle.includes(code);
    if (!eligibleBundle || !address || !linecheckId) {
      if (typeof lineCheckCallBack === 'function') lineCheckCallBack();
    } else if (isAvailable) {
      //track event add to cart
      Object.keys(offerData)?.length !== 0 &&
        trackEligibleItem(ADDTOCART, [offerData], selectedProduct, STICKYLINETABLE);
      //Create cart call not triggered if offer api fails
      Object.keys(offerData)?.length !== 0 &&
        createCartV2(
          [offerData],
          '',
          offerData?.promoId ? offerData?.promoId : DEFAULT_WIRELINE_BUNDLE,
          cartEndPoint,
          FIXNET
        )
          .then((res) => {
            Cookies.remove('one-commerce-cartId', { path: '/' });
            // saving newly created cartid in the cookies.
            Cookies.set('one-commerce-cartId', res?.id, { path: '/' });
            Cookies.set('cartProduct', code, { path: '/' });
            Cookies.remove('landline');
            window.location.href = selectedProduct?.checkoutUrl ?? '';
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
    }
  };

  const priceSection = () => {
    return (
      <div className={Styles.priceSection}>
        {CHF} {countZero(productPrice)}
        <span className={Styles.priceDuration}>{selectedProduct?.monthText}</span>
      </div>
    );
  };
  useEffect(() => {
    const handleScroll = () => {
      const ele = document.getElementById('productTeaser');
      if (!ele) return;
      const { top, bottom } = ele.getBoundingClientRect();
      const windowHeight = window?.innerHeight || document.documentElement.clientHeight;

      if (top < windowHeight && bottom >= 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
      let headerDiv: any = document.querySelectorAll('.sticky-header2');
      const ele1 = document.getElementById('stickyAnchorContainer');
      const falconHeader = document.querySelectorAll('.sticky-header');
      if (falconHeader != null) {
        const FalconStyle = falconHeader?.length > 0 ? 'falconStyle' : 'noFalconStyle';
        setHead(FalconStyle);
      }
      if (headerDiv != null) {
        const headerHeight = headerDiv?.[0]?.offsetHeight;
        const tabStyle = headerHeight >= 75 ? 'noFalconStyle2' : 'falconStyle2';
        setHead2(tabStyle);
      }

      const offset = ele1?.offsetTop;
      if (offset && window.scrollY > offset) {
        setOffsetVal(true);
      } else {
        setOffsetVal(false);
      }

      const ele2 = document.getElementById('dropDownContainer');

      const offset2 = ele2?.offsetTop;
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    setDrop(!drop);
  };

  let portal;
  try {
    portal = document.getElementsByTagName('header')?.[0]
  } catch (err: any) {

  }

  if (!portal) return <></>;


  return <>
      {selectedProduct?.productName && (
        <>
        {createPortal(<>
          <div
            className={`${Styles.stickyAnchorContainer}  ${
              offsetVal ? Styles.offsetClass : Styles.nonOffsetClass
            } ${Styles[head]} ${Styles[head2]}`}
            id='stickyAnchorContainer'
          >
            <Row>
              <div className={Styles.productContainer}>
                <div className={Styles.productTitle}>
                  {(viewPort === TABLET || viewPort === MOBILE) && (
                    <img
                      onClick={handleClick}
                      className={`${Styles.arrowIcon} ${
                        !drop ? Styles.counterclockwise : Styles.clockwise
                      }`}
                      src={selectedProduct?.arrowUp?.filename}
                      alt='arrowIcon'
                    />
                  )}
                  <div>
                    {selectedProduct?.productName}
                    <div className={Styles.productPrice}>
                      {productPrice > 0 && (viewPort === TABLET || viewPort === MOBILE) && (
                        <>{priceSection()}</>
                      )}
                    </div>
                  </div>
                </div>
                <div className={Styles.contentWrapper}>
                  {viewPort !== TABLET && viewPort !== MOBILE && (
                    <>
                      <span className={Styles.benefitsContainer}>
                        {(selectedProduct?.benefits || [])?.map((benefit: any) => (
                          <div className={Styles.benefits} onClick={() => scroller(benefit)}>
                            {benefit?.title}
                          </div>
                        ))}
                      </span>
                      {productPrice > 0 && <>{priceSection()}</>}
                    </>
                  )}
                  {selectedProduct?.buyBtn && (
                    <button
                      className={Styles.buyNowButton}
                      onClick={
                        selectedProduct?.productType === MOBILE
                          ? callCart
                          : callCartWin
                      }
                    >
                      {selectedProduct?.buyBtn}
                    </button>
                  )}
                </div>
              </div>
            </Row>
          </div>
          {selectedProduct?.productName && drop && (
            <div
              className={`${Styles.stickyAnchorContainer} ${
                offsetVal ? Styles.offsetClass2 : Styles.nonOffsetClass
              }`}
              id='dropDownContainer'
            >
              <span className={Styles.benefitsContainer2}>
                {(selectedProduct?.benefits || [])?.map((benefit: any) => (
                  <div
                  className={Styles.subcontain}
                    // style={{ margin: '0px 57px 20px', cursor: 'pointer' }}
                    onClick={() => scroller(benefit)}
                  >
                    {benefit?.title}
                  </div>
                ))}
              </span>
            </div>
          )}
        </>, portal)}
    </>)}
    </>
};

export default StickyProductAnchor;
